import Footer from '../../components/Footer/Footer';
import SideBar from '../../components/SideBar/SideBar';
import NavBar1 from '../../components/Navbar1/NavBar1';
// import BlankSpace from '../../components/BlankSpace/BlankSpace';
import Cart from '../../components/Cart/Cart';



const cart = (props) => { 
    
    return (
        <>
            <NavBar1 />
            <SideBar>
                <Footer>
                    
                        <Cart/>
                    
                        
                   
                </Footer>
            </SideBar>
        </>  
    );
}

export default cart;